// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:27:43

export default {
  "id": "mr-bullet-stealth-ninja-killstreak",
  "slug": "mr-bullet-stealth-ninja-killstreak",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/5c3bbdcd66684b69aa7cb06ad3b7ccf3-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/5c3bbdcd66684b69aa7cb06ad3b7ccf3/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Mr Bullet: Stealth Ninja Killstreak",
      "description": "Stealth action about a special agent! Third-person shooter about secret missions. Shootouts with stickmen. Physical destruction! Battles with dangerous Bosses. Tanks, Helicopters, Mutants! Road chases with destructible cars and much more!",
      "instructions": "To win - you need to eliminate all opponents on the level.\nControls:\nPC - use the mouse to control the camera. Shooting is automatic when the sight is aimed at the enemy.\nMobile - use your finger to control the camera. Shooting is automatic when the sight is aimed at the enemy.",
      "genres": [
        "Casual",
        "Shooter"
      ],
      "tags": [
        "3d",
        "aim",
        "fighting",
        "ninja",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "子弹先生：潜行忍者连杀爆发",
      "description": "潜行动作游戏，关于一名特务！第三人称射击游戏，关于秘密任务。与棍人进行枪战。物理破坏！与危险Boss的战斗。坦克、直升机、变种人！可破坏的汽车追逐以及更多！",
      "instructions": "要胜利 - 您需要消灭关卡上的所有敌人。\n控制方式：\nPC - 使用鼠标控制摄像头。瞄准敌人时自动射击。\n移动设备 - 使用手指控制摄像头。瞄准敌人时自动射击。",
      "genres": [
        "休闲",
        "射击"
      ],
      "tags": [
        "三维",
        "瞄准",
        "格斗",
        "忍者",
        "木偶人"
      ]
    },
    "zh-TW": {
      "title": "布萊特先生：潛行忍者殺戮狂潮",
      "description": "潜行動作遊戲，關於一名特別探員！第三人稱射擊遊戲，關於秘密任務。對決與木棍人。物理破壞！與危險BOSS的戰鬥。坦克、直升機、變異種！可破壞車輛的道路追逐，還有更多！",
      "instructions": "要獲勝 - 你需要消滅該關卡上所有的對手。\n控制方式：\nPC - 使用滑鼠操控相機。當瞄准敵人時，射擊會自動發射。\n手機 - 使用手指操控相機。當瞄准敵人時，射擊會自動發射。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "3D",
        "瞄准",
        "格鬥",
        "忍者",
        "黏人角色"
      ]
    },
    "zh-HK": {
      "title": "Mr Bullet: 潛行忍者殺戮狂潮",
      "description": "潜行動作遊戲，關於特別調查員！第三身射擊關於秘密任務。用木人進行的槍戰。物理破壞！與危險的Boss戰鬥。坦克、直升機、變異生物！可毀壞車輛的公路追逐，以及更多！",
      "instructions": "要獲勝 - 你需要消滅該關卡上所有敵人。\n控制方式：\nPC - 使用滑鼠控制鏡頭。當視線對準敵人時，射擊會自動進行。\n手機 - 使用手指控制鏡頭。當視線對準敵人時，射擊會自動進行。",
      "genres": [
        "休闲",
        "射擊"
      ],
      "tags": [
        "3D",
        "狙擊",
        "格鬥",
        "忍者",
        "木人"
      ]
    },
    "ja": {
      "title": "バレット先生：スティル・ニンジャ・キルストライク",
      "description": "スパイエージェントの潜入アクション！秘密の作戦のためのサードパーソン・シューティング。スティックマンとの銃撃戦。物理的な破壊！危険なボスとの戦闘。戦車、ヘリコプター、変異体！壊れることができる車でのロードチェイスなど、多くの要素を含む！",
      "instructions": "勝つためには - レベル内の全ての敵を倒す必要があります。\nコントロール：\nPC - カメラの操作にはマウスを使用します。敵に照準を合わせると自動的に射撃が行われます。\nモバイル - カメラの操作には指を使用します。敵に照準を合わせると自動的に射撃が行われます。",
      "genres": [
        "カジュアル",
        "シューティング"
      ],
      "tags": [
        "3D",
        "aim",
        "ファイティング",
        "忍者",
        "ストックマン"
      ]
    },
    "ko": {
      "title": "미스터 불릿: 스타일드 닌자 킬스트림",
      "description": "스파이 액션! 특수 요원의 third-person shooter. 비밀 임무에 대한 쏘아대기. stickmen과의 쏘아대기. 물리적 파괴! 위험한 보스와의 전투. 탱크, 헬리콥터, 변異자! 파괴 가능한 차량으로의 도로 추격과 더 많은 것들!",
      "instructions": "승리하기 위해 - 해당 레벨에서 모든 상대를 제거해야 합니다.\n제어 방법:\nPC - 캠에 대해서는 마우스를 사용하여 제어합니다. 적에 시야를 맞추면 자동으로 발사됩니다.\n모바일 - 캠에 대해서는 손가락을 사용하여 제어합니다. 적에 시야를 맞추면 자동으로 발사됩니다.",
      "genres": [
        "캐주얼",
        "셔터"
      ],
      "tags": [
        "3D",
        "정면 공격",
        "전투",
        "닌자",
        "스티커맨"
      ]
    },
    "fr": {
      "title": "M. Bullet : NinJa Furtif Tuerie En Chaîne",
      "description": "Action de furtivité sur un agent spécial ! Tiraillage à la troisième personne pour des missions secrètes. Affrontements avec des stickmen. Destruction physique ! Combats contre des Boss dangereux. Tanks, Hélicoptères, Mutants ! Chasses en route avec des voitures destructibles et bien plus encore !",
      "instructions": "Pour gagner - vous devez éliminer tous les adversaires sur le niveau.\nContrôles :\nPC - utilisez la souris pour contrôler la caméra. Le tir est automatique lorsque le viseur est pointé sur l'ennemi.\nMobile - utilisez votre doigt pour contrôler la caméra. Le tir est automatique lorsque le viseur est pointé sur l'ennemi.",
      "genres": [
        "Facile",
        "tireur"
      ],
      "tags": [
        "3D",
        "tireur d'élite",
        "combat",
        "ninja",
        "stickman"
      ]
    }
  }
};
